import FamilyDocumentsFormComponent from "../../components/info-beneficiary/FamilyDocumentsFormComponent";

export default function FamilyDocumentsBloc() {

      return (
        <div className="">
          <div className="">
            <h2 className="card-title bleu">Justificatif de situation familiale</h2>
            {/* <p className="text m-y-sm">Veuillez télécharger le(s) document(s) suivants (.pdf, .jpg, .jpeg ou .png) :</p> */}
            <FamilyDocumentsFormComponent />
          </div>
        </div>
      )
}